import { ResourceType } from "./resource-type";

export const FILES_EXPLORER_RESOURCE_TYPES = [ResourceType.Model, ResourceType.Artifact] as const;
